;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();export const EXACT_AMOUNT_INFO_SHOWN = 'exact-amount-info-shown';

export const USER_PHONE_NUMBER = 'user-phone-number';

export const HERO_CALC_PROMO_DISMISSED = 'hero-calc-promo-dismissed-v1';

export const LOCAL_STORAGE_CHANGE_EVENT_NAME = 'LOCAL_STORAGE_CHANGE';
